// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__chat_container {
  width: 100%;
  position: fixed;
  top: 20;
  right: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
}
.__chat_container .__chat {
  pointer-events: auto;
  position: absolute;
  top: 0;
  width: 60%;
  right: 0;
  height: 84vh;
  background-color: rgba(0, 0, 0, 0.75);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  outline: 0.3px solid #ffee20;
}
@media (max-width: 576px) {
  .__chat_container .__chat {
    width: 50%;
    left: 0;
  }
}
.__chat_container .__chat .__chat_header {
  border-radius: 20px 20px 0 0;
  background-color: rgba(0, 0, 0, 0.75);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: 16px 16px 10px;
}
.__chat_container .__chat .__chat_typing {
  position: absolute;
  bottom: 44px;
  padding: 0 16px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3019607843);
}
.__chat_container .__chat .__chat_typing .__typing {
  color: #BDBDBD;
  font-style: italic;
  font-size: 12px;
}
.__chat_container .__chat ._chat_tippers_icon {
  position: absolute;
  right: 0;
  z-index: 1;
  cursor: pointer;
}
.__chat_container .__chat .__chat_messages {
  position: absolute;
  width: calc(100% - 32px);
  height: calc(100% - 118px);
  overflow: scroll;
  position: relative;
  padding: 16px;
  top: 0px;
}
.__chat_container .__chat .__chat_send {
  background-color: #171515;
  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.3019607843);
  width: 100%;
  height: 44px;
  position: absolute;
  bottom: 0;
  border-radius: 0 0 20px 20px;
}
.__chat_container .__chat .__chat_send .__chat_tip {
  width: 26px;
  padding-left: 16px;
}
.__chat_container .__chat .__chat_send .__chat_input {
  border: 0px !important;
  border-radius: 0 !important;
  border-color: none !important;
  background: transparent;
  resize: none;
  padding: 14px 0;
  width: 90%;
  color: #ffffff;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
.__chat_container .__chat .__chat_send .__chat_input:focus {
  outline: none !important;
}
.__chat_container .__chat .__chat_send .__sent_botton {
  width: 20px;
  padding-right: 10px;
  cursor: pointer;
}

.__chat_tip_container,
._chat_onlineUsers,
.__chat_more_data {
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100% - 0px);
  z-index: 10000;
}
.__chat_tip_container ._chat_tip_box_header,
.__chat_tip_container ._chat_onlineUsers_headers,
.__chat_tip_container .__chat_more_data_header,
._chat_onlineUsers ._chat_tip_box_header,
._chat_onlineUsers ._chat_onlineUsers_headers,
._chat_onlineUsers .__chat_more_data_header,
.__chat_more_data ._chat_tip_box_header,
.__chat_more_data ._chat_onlineUsers_headers,
.__chat_more_data .__chat_more_data_header {
  background: #171515;
  padding: 10px 16px 8px 16px;
  border-radius: 20px 20px 0 0;
}
.__chat_tip_container ._chat_tip_box_hide,
.__chat_tip_container ._chat_onlineUsers_box_hide,
._chat_onlineUsers ._chat_tip_box_hide,
._chat_onlineUsers ._chat_onlineUsers_box_hide,
.__chat_more_data ._chat_tip_box_hide,
.__chat_more_data ._chat_onlineUsers_box_hide {
  padding: 16px;
  height: 0px;
  background: #1e1e1e;
  transition: height 0.5s ease-out;
}
.__chat_tip_container ._chat_tip_box,
.__chat_tip_container ._chat_onlineUsers_box,
.__chat_tip_container .__chat_more_data_box,
._chat_onlineUsers ._chat_tip_box,
._chat_onlineUsers ._chat_onlineUsers_box,
._chat_onlineUsers .__chat_more_data_box,
.__chat_more_data ._chat_tip_box,
.__chat_more_data ._chat_onlineUsers_box,
.__chat_more_data .__chat_more_data_box {
  padding: 16px;
  height: calc(100% - 106px);
  overflow: scroll;
  background: #171515;
  transition: height 0.5s ease-in;
}
.__chat_tip_container ._chat_tip_box .__playlist_chat_song_selected,
.__chat_tip_container ._chat_onlineUsers_box .__playlist_chat_song_selected,
.__chat_tip_container .__chat_more_data_box .__playlist_chat_song_selected,
._chat_onlineUsers ._chat_tip_box .__playlist_chat_song_selected,
._chat_onlineUsers ._chat_onlineUsers_box .__playlist_chat_song_selected,
._chat_onlineUsers .__chat_more_data_box .__playlist_chat_song_selected,
.__chat_more_data ._chat_tip_box .__playlist_chat_song_selected,
.__chat_more_data ._chat_onlineUsers_box .__playlist_chat_song_selected,
.__chat_more_data .__chat_more_data_box .__playlist_chat_song_selected {
  background: #3a3a3a;
  padding: 5px 0;
}

emoji-picker {
  position: absolute;
  z-index: 10;
  bottom: 3em;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/Chat/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA3BA;EACI,WAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;AA6BJ;AA3BI;EACI,oBAAA;EAIA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,4BAAA;AAiBR;ADFE;ECxBE;IAaQ,UAAA;IACA,OAAA;EA4BV;AACF;AA1BQ;EACI,4BAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,uBAAA;AA4BZ;AAzBQ;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,6CAAA;AA2BZ;AAzBY;EACI,cAAA;EACA,kBAAA;EAGA,eAAA;AAyBhB;AArBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAuBZ;AApBQ;EACI,kBAAA;EACA,wBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;AAsBZ;AAnBQ;EACI,yBAAA;EAEA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;AAoBZ;AAlBY;EACI,WAAA;EACA,kBAAA;AAoBhB;AAjBY;EACI,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EAMA,uDAAA;AAchB;AAlBgB;EACI,wBAAA;AAoBpB;AAXY;EACI,WAAA;EACA,mBAAA;EACA,eAAA;AAahB;;AAPA;;;EAGI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,cAAA;AAUJ;AARI;;;;;;;;;EAGI,mBAAA;EACA,2BAAA;EACA,4BAAA;AAgBR;AAbI;;;;;;EAEI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;AAmBR;AAhBI;;;;;;;;;EAGI,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAwBR;AAtBQ;;;;;;;;;EACI,mBAAA;EACA,cAAA;AAgCZ;;AA3BA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AA8BJ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n.__chat_container {\n    width: 100%; // Ensure it takes the full width if needed\n    position: fixed;\n    top: 20;\n    right: 0; // Position the chat on the right side\n    transition: all 0.3s ease-in-out;\n    pointer-events: none; // Ignore clicks outside the visible chat area\n\n    .__chat {\n        pointer-events: auto; // Allow clicks only within the chat box\n      }\n    \n    .__chat {\n        position: absolute;\n        top: 0;\n        width: 60%;\n        right: 0;\n        height: 84vh;\n        background-color: rgba(0, 0, 0, 0.75); // Darker semi-transparent black\n        backdrop-filter: blur(10px); // Frosted glass effect\n        border-radius: 20px;\n        outline: .3px solid #ffee20; // Thin yellow outline\n\n\n        @include sm {\n            width: 50%;\n            left: 0;\n        }\n\n        .__chat_header {\n            border-radius: 20px 20px 0 0;\n            background-color: rgba(0, 0, 0, 0.75); // Match frosted effect\n            backdrop-filter: blur(10px); // Apply blur to header\n            padding: 16px 16px 10px;\n        }\n\n        .__chat_typing {\n            position: absolute;\n            bottom: 44px;\n            padding: 0 16px;\n            width: 100%;\n            background-color: #0000004d;\n\n            .__typing {\n                color: #BDBDBD;\n                font-style: italic;\n\n\n                font-size: 12px;\n            }\n        }\n\n        ._chat_tippers_icon {\n            position: absolute;\n            right: 0;\n            z-index: 1;\n            cursor: pointer;\n        }\n\n        .__chat_messages {\n            position: absolute;\n            width: calc(100% - 32px);\n            height: calc(100% - 118px);\n            overflow: scroll;\n            position: relative;\n            padding: 16px;\n            top: 0px;\n        }\n\n        .__chat_send {\n            background-color: #171515;\n\n            box-shadow: 0px -6px 12px #0000004d;\n            width: 100%;\n            height: 44px;\n            position: absolute;\n            bottom: 0;\n            border-radius: 0 0 20px 20px;\n\n            .__chat_tip {\n                width: 26px;\n                padding-left: 16px;\n            }\n\n            .__chat_input {\n                border: 0px !important;\n                border-radius: 0 !important;\n                border-color: none !important;\n                background: transparent;\n                resize: none;\n                padding: 14px 0;\n                width: 90%;\n                color: #ffffff;\n\n                &:focus {\n                    outline: none !important;\n                }\n\n                font-family: \"Roboto\",\n                \"Helvetica\",\n                \"Arial\",\n                sans-serif;\n            }\n\n            .__sent_botton {\n                width: 20px;\n                padding-right: 10px;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n.__chat_tip_container,\n._chat_onlineUsers,\n.__chat_more_data {\n    position: absolute;\n    top: 0px;\n    width: 100%;\n    height: calc(100% - 0px);\n    z-index: 10000;\n\n    ._chat_tip_box_header,\n    ._chat_onlineUsers_headers,\n    .__chat_more_data_header {\n        background: #171515;\n        padding: 10px 16px 8px 16px;\n        border-radius: 20px 20px 0 0;\n    }\n\n    ._chat_tip_box_hide,\n    ._chat_onlineUsers_box_hide {\n        padding: 16px;\n        height: 0px;\n        background: #1e1e1e;\n        transition: height 0.5s ease-out;\n    }\n\n    ._chat_tip_box,\n    ._chat_onlineUsers_box,\n    .__chat_more_data_box {\n        padding: 16px;\n        height: calc(100% - 106px);\n        overflow: scroll;\n        background: #171515;\n        transition: height 0.5s ease-in;\n\n        .__playlist_chat_song_selected {\n            background: #3a3a3a;\n            padding: 5px 0;\n        }\n    }\n}\n\nemoji-picker {\n    position: absolute;\n    z-index: 10;\n    bottom: 3em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
